<script setup>
import { useConfirmModalStore } from "~/stores/confirmModelState.js";
import { storeToRefs } from "pinia";

const store = useConfirmModalStore();
const { modalText, toggleConfirmModal } = storeToRefs(store)
const { closeModal } = store
</script>

<template>
<div :class="{ container: true, active: toggleConfirmModal }">
  <p v-html="modalText"></p>
  <button @click="closeModal">확인</button>
</div>
</template>

<style scoped lang="scss">
  .container.active {
    display: flex;
  }

  .container {
    display: none;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    width: 312px;
    height: 172px;

    position: absolute;
    top: 50%;
    left: 50%;
    z-index: 99996;
    transform: translate(-50%, -50%);

    background-color: #FFF;

    & p {
      padding: 0;
      margin: 0 0 24px 0;
      line-height: 1.5;
      font-size: 20px;
      font-weight: 600;
    }

    & button {
      width: 280px;
      height: 40px;
      border-radius: 4px;
      border: none;
      font-size: 20px;
      font-weight: 600;
      color: #FFF;
      background-color: #3289FA;
      cursor: pointer;
    }
  }

  @media (max-width: 960px) {
    .container {
      top: 55%;
    }
  }
</style>